module.exports = __webpack_public_path__ + "static/media/longarrowaltright.11a19e3c.svg";